module.exports = __webpack_public_path__ + "img/btn-trans.c1778c32.png";